import { render, staticRenderFns } from "./PerformanceSuggestionPanel.vue?vue&type=template&id=4ec54b19&scoped=true"
import script from "./PerformanceSuggestionPanel.vue?vue&type=script&lang=js"
export * from "./PerformanceSuggestionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec54b19",
  null
  
)

export default component.exports